import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-inbox }}\n{{outlet}}",{ moduleName: "embercom/templates/inbox.hbs" })